<script>
	import * as util from "cando-util";

	import { store } from "$lib/utilities/store";
	import { getSession } from "$lib/utilities/getSession";
	import { translate } from "$lib/utilities/translate";

	// import { userProfile } from '../lib/stores/userProfile.js';
	// import { userRoles } from '../lib/stores/userRoles.js';

	// import { settings } from '../lib/stores/settings.js';
	// import { extensions } from '../lib/stores/extensions';
	// import { scripts } from '../lib/stores/scripts.js';
	// import { documents } from '../lib/stores/documents.js';

	// import { profiles } from '../lib/stores/profiles.js';
	// import { roles } from '../lib/stores/roles.js';

	// import { appSettings } from '../lib/stores/appSettings';

	// import { telephonySessions } from '../lib/stores/telephonySessions.js';

	import { webSocketMessages } from "$lib/stores/webSocketMessages.js";

	// import { pdfStore } from '../lib/components/CallScript/generatePDF.js';

	import { convertVnsCallScriptToAiAgent } from "$lib/utilities/convertVnsCallScriptToAiAgent.js";

	export let lang;
	export let area;

	// // tests
	// import { testSettingsModule } from './settings/tests.js';
	// import { testRolesModule } from './roles/tests.js';
	// import { testForDuplicateTagIds } from './tests.js';

	// $: util.watchObject(util, 'util');

	// // TODO: let's keep the utilities in the util part of the namespace
	// $: util.watchObject(util.capitalizeEachWord, 'capitalizeEachWord');
	// $: util.watchObject(util.currencyFormatter, 'currencyFormatter');
	// $: util.watchObject(util.currencyToNumber, 'currencyToNumber');
	// $: util.watchObject(util.calculatePayments, 'calculatePayments');
	// $: util.watchObject(util.isValidDateMDY, 'isValidDateMDY');
	$: util.watchObject(getSession, "getSession");
	$: util.watchObject(util.getFirmFromSession, "getFirmFromSession");
	$: util.watchObject(translate, "translate");

	// // stores
	// $: util.watchObject({ ...$userProfile, set: userProfile.set }, 'userProfile');
	// $: util.watchObject({ ...$userRoles, set: userRoles.set }, 'userRoles');
	// $: util.watchObject({ ...$settings, set: settings.set }, 'settings');
	// $: util.watchObject({ ...$extensions, set: extensions.set }, 'extensions');
	// $: util.watchObject({ ...$scripts, set: scripts.set }, 'scripts');
	// $: util.watchObject({ ...$documents, set: documents.set }, 'documents');

	// $: util.watchObject({ ...$profiles, set: profiles.set }, 'profiles');
	// $: util.watchObject({ ...$roles, set: roles.set }, 'roles');

	// $: util.watchObject({ ...$appSettings, set: appSettings.set }, 'appSettings');

	// $: util.watchObject({ ...$telephonySessions, set: telephonySessions.set }, 'telephonySessions');
	$: util.watchObject(
		{ ...$webSocketMessages, set: webSocketMessages.set },
		"webSocketMessages",
	);
	// $: util.watchObject({ ...$pdfStore, set: pdfStore.set }, 'pdfStore');

	// // tests
	// $: util.watchObject(testSettingsModule, 'testSettingsModule');
	// $: util.watchObject(testRolesModule, 'testRolesModule');
	// $: util.watchObject(testForDuplicateTagIds, 'testForDuplicateTagIds');

	$: util.watchObject(lang, "lang");
	$: util.watchObject(area, "area");

	$: util.watchObject($store, "store");
	$: util.watchObject(util, "util");

	$: util.watchObject(
		convertVnsCallScriptToAiAgent,
		"convertVnsCallScriptToAiAgent",
	);
</script>
